import React from "react";
import { useMediaQuery } from "react-responsive";

const pageStyle = {
  minHeight: "100vh",
  background: "#f5f7fb",
  color: "#1f2937",
  fontFamily:
    '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
  lineHeight: 1.65,
};

const wrapStyle = {
  maxWidth: "920px",
  margin: "0 auto",
  padding: "28px 18px 48px",
};

const cardStyle = {
  background: "#fff",
  borderRadius: "12px",
  boxShadow: "0 4px 18px rgba(15, 42, 74, 0.08)",
  padding: "32px 28px",
};

const titleStyle = {
  margin: "0 0 8px",
  color: "#186cc2",
  fontSize: "1.85rem",
  fontWeight: 700,
  textAlign: "center",
};

const subtitleStyle = {
  margin: "0 0 10px",
  fontSize: "1.3rem",
  fontWeight: 700,
  textAlign: "center",
};

const orgStyle = {
  margin: "0 0 20px",
  fontSize: "1.15rem",
  color: "#4b5563",
  textAlign: "center",
};

const introStyle = {
  margin: "0 0 22px",
  fontSize: "1.2rem",
};

const sectionTitleStyle = {
  margin: "26px 0 12px",
  fontSize: "1.28rem",
  fontWeight: 700,
  color: "#111827",
  borderBottom: "1px solid #e5e7eb",
  paddingBottom: "6px",
};

const listStyle = {
  margin: "0 0 10px",
  paddingLeft: "20px",
};

const itemStyle = {
  marginBottom: "12px",
  fontSize: "1.2rem",
};

const nestedListStyle = {
  margin: "6px 0 0",
  paddingLeft: "20px",
};

const declarationStyle = {
  marginTop: "28px",
  padding: "16px 18px",
  background: "#eff6ff",
  border: "1px solid #bfdbfe",
  borderRadius: "10px",
  fontSize: "1.2rem",
};

const AamdarChashakTerms = () => {
  const isMobile = useMediaQuery({ query: "(max-width: 1224px)" });
  const wrap = isMobile
    ? { ...wrapStyle, padding: "140px 14px 48px" }
    : wrapStyle;
  const title = isMobile
    ? { ...titleStyle, fontSize: "1.55rem" }
    : titleStyle;
  const subtitle = isMobile
    ? { ...subtitleStyle, fontSize: "1.25rem" }
    : subtitleStyle;
  const org = isMobile ? { ...orgStyle, fontSize: "1.15rem" } : orgStyle;
  const intro = isMobile ? { ...introStyle, fontSize: "1.22rem" } : introStyle;
  const sectionTitle = isMobile
    ? { ...sectionTitleStyle, fontSize: "1.28rem" }
    : sectionTitleStyle;
  const item = isMobile ? { ...itemStyle, fontSize: "1.22rem" } : itemStyle;
  const declaration = isMobile
    ? { ...declarationStyle, fontSize: "1.22rem" }
    : declarationStyle;
  const card = isMobile
    ? { ...cardStyle, padding: "24px 16px" }
    : cardStyle;

  return (
    <div style={pageStyle}>
      <div style={wrap}>
        <div style={card}>
          <h1 style={title}>AAMDAR CHASHAK SEASON 2, 2027</h1>
          <h2 style={subtitle}>CONSOLIDATED GENERAL TERMS &amp; CONDITIONS</h2>
          <p style={org}>
            Organiser: Varsova Citizen Charitable Trust | All Rights Reserved
          </p>
          <p style={intro}>
            By registering, participating, or bidding, all Players and Team
            Owners unreservedly agree to these Terms &amp; Conditions:
          </p>

          <h3 style={sectionTitle}>
            SECTION 1: ORGANISER AUTHORITY &amp; RIGHTS
          </h3>
          <ul style={listStyle}>
            <li style={item}>
              <strong>1.1 Sole Governing Authority:</strong> The Organiser is
              the sole authority for the management, rules, scheduling, venue
              selection, formatting, and overall conduct of the Tournament.
            </li>
            <li style={item}>
              <strong>1.2 Finality of Decisions:</strong> All decisions of the
              Organising Committee regarding eligibility, document scrutiny,
              auctions, match operations, disputes, and disciplinary actions
              shall be final, binding, and non-appealable. No appeal shall lie
              against the Organiser&apos;s decision.
            </li>
            <li style={item}>
              <strong>1.3 General Rights:</strong> The Organiser reserves the
              absolute right to accept, reject, or modify rules, schedules,
              venues, or any registration at any time without assigning any
              reason.
            </li>
          </ul>

          <h3 style={sectionTitle}>
            SECTION 2: PLAYER ELIGIBILITY (DO&apos;S &amp; DON&apos;TS)
          </h3>
          <ul style={listStyle}>
            <li style={item}>
              <strong>2.1 Requirements (Do&apos;s):</strong>
              <ul style={nestedListStyle}>
                <li style={item}>
                  <strong>Age Limit:</strong> Players must be{" "}
                  <strong>16 years of age or above</strong> as of January 1,
                  2027 (unless a separate junior category is officially
                  announced).
                </li>
                <li style={item}>
                  <strong>Verification:</strong> Players must provide authentic
                  credentials including true Name, Date of Birth, Mobile Number,
                  Address Proof, and Photo ID.
                </li>
                <li style={item}>
                  <strong>Fitness:</strong> Players must be medically fit to
                  participate in active cricket.
                </li>
              </ul>
            </li>
            <li style={item}>
              <strong>2.2 Restrictions (Don&apos;ts):</strong>
              <ul style={nestedListStyle}>
                <li style={item}>
                  <strong>Prohibition of Fraud:</strong> No player shall
                  register with a fake name, age, or falsified documents. Age
                  fraud will lead to an immediate{" "}
                  <strong>lifetime ban</strong> from Aamdar Chashak without
                  refund.
                </li>
                <li style={item}>
                  <strong>Professional Player Bar:</strong> No professional,
                  Ranji Trophy, or IPL contracted player is allowed to
                  participate unless prior written permission is granted by the
                  Organiser.
                </li>
                <li style={item}>
                  <strong>Single Registration:</strong> One player cannot
                  register for or represent more than one team in Season 2.
                </li>
              </ul>
            </li>
          </ul>

          <h3 style={sectionTitle}>
            SECTION 3: MODE OF REGISTRATION &amp; PAYMENT POLICY
          </h3>
          <ul style={listStyle}>
            <li style={item}>
              <strong>3.1 Exclusive Online Mode:</strong> No offline, paper, or
              physical registration form shall be accepted under any
              circumstances. Only online forms submitted through the official
              portal (
              <a
                href="https://superplayerauction.com/user/join-auction-code3"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://superplayerauction.com/user/join-auction-code3
              </a>
              ) shall be entertained and accepted. Any list, request, or form
              sent via WhatsApp, paper, or verbally will be treated as null and
              void.
            </li>
            <li style={item}>
              <strong>3.2 Zero Cash Policy:</strong> No cash transactions are
              accepted. The Organiser does not authorize any individual to
              collect cash. Any cash paid to any individual is entirely at the
              player&apos;s own risk; the Organiser accepts no responsibility or
              liability for such transactions.
            </li>
            <li style={item}>
              <strong>3.3 Online Payment Process:</strong> Payment shall be made
              exclusively via the official online mode (UPI / QR Code displayed
              on the registration form). Players must enter the correct UPI
              Transaction ID and upload a valid payment screenshot for
              verification.
            </li>
            <li style={item}>
              <strong>3.4 Completion of Registration:</strong> Registration is
              deemed complete <strong>only</strong> when the online form is
              submitted, online payment is received, and Admin/Organiser
              approval is granted.
            </li>
          </ul>

          <h3 style={sectionTitle}>
            SECTION 4: SHORTLISTING, AUCTION RULES &amp; TEAM LOYALTY
          </h3>
          <ul style={listStyle}>
            <li style={item}>
              <strong>4.1 Scrutiny &amp; Shortlisting:</strong> Eligible players
              shall be shortlisted by the Organising Committee after strict
              scrutiny of submitted documents. Mere online registration and fee
              payment do not guarantee entry into the auction.
            </li>
            <li style={item}>
              <strong>4.2 Publication:</strong> The official list of shortlisted
              players will be published on the official group/platform and put
              up for auction. Non-shortlisted players will be informed and
              refunded per Section 5. Unsold players have no right to claim
              match inclusion.
            </li>
            <li style={item}>
              <strong>4.3 Auction Logistics:</strong> Base prices, team purses,
              retention rules, and bidding increments will be decided solely by
              the Organiser.
            </li>
            <li style={item}>
              <strong>4.4 Team Owner Obligations:</strong> Team Owners must
              clear their full auction purse and team fees before the designated
              deadline. Defaulting on payment will lead to cancellation of the
              team.
            </li>
            <li style={item}>
              <strong>4.5 Anti-Collusion:</strong> No collusion, match-fixing,
              or pre-auction side deals are permitted. Anyone found guilty will
              face immediate bans and legal action.
            </li>
            <li style={item}>
              <strong>4.6 Team Loyalty Clause:</strong>
              <ul style={nestedListStyle}>
                <li style={item}>
                  A player must play exclusively for the team they are sold to /
                  purchased by in the auction.
                </li>
                <li style={item}>
                  A player cannot refuse to play for their auctioned team,
                  cannot demand a transfer, and cannot play for any other team
                  in Season 2.
                </li>
                <li style={item}>
                  If a sold player refuses to play, they will be treated as{" "}
                  <strong>banned for Season 2 and Season 3</strong> without
                  refund, and their auction amount will be forfeited by the team
                  owner.
                </li>
              </ul>
            </li>
          </ul>

          <h3 style={sectionTitle}>
            SECTION 5: REFUND POLICY &amp; UNSOLD PLAYERS
          </h3>
          <ul style={listStyle}>
            <li style={item}>
              <strong>5.1 Refund for Unsold Players:</strong> Registration fees
              shall be returned if a shortlisted player remains unsold during
              the official auction.
            </li>
            <li style={item}>
              <strong>5.2 Disbursement Timeline:</strong> The refund amount
              shall be processed and returned within{" "}
              <strong>15 working days</strong> after the auction date.
            </li>
            <li style={item}>
              <strong>5.3 Payment Channel:</strong> Refunds shall be remitted{" "}
              <strong>ONLY</strong> to the same UPI ID / Bank Account / Phone
              Number from which the original payment was received. No request
              for a change of refund account will be entertained. No interest
              shall be payable on refunds.
            </li>
            <li style={item}>
              <strong>5.4 Non-Refundable Scenarios:</strong>
              <ul style={nestedListStyle}>
                <li style={item}>
                  Fees are strictly non-refundable and non-transferable in
                  general cases, including rejection, player injury, rain,
                  tournament cancellation, or disqualification.
                </li>
                <li style={item}>
                  Players who are shortlisted and sold in the auction are{" "}
                  <strong>NOT</strong> eligible for a refund.
                </li>
                <li style={item}>
                  Players who violate eligibility rules or the Code of Conduct
                  forfeit all rights to a refund.
                </li>
              </ul>
            </li>
          </ul>

          <h3 style={sectionTitle}>
            SECTION 6: CODE OF CONDUCT &amp; DISCIPLINARY POLICY
          </h3>
          <ul style={listStyle}>
            <li style={item}>
              <strong>6.1 Zero Tolerance:</strong> Indiscipline will not be
              tolerated in any form, both on and off the ground.
            </li>
            <li style={item}>
              <strong>6.2 Prohibited Acts (Don&apos;ts):</strong>
              <ul style={nestedListStyle}>
                <li style={item}>
                  Abuse, fighting, or misbehaviour with umpires, organisers,
                  opponents, or the public.
                </li>
                <li style={item}>
                  Possession or consumption of{" "}
                  <strong>
                    alcohol, smoking/tobacco products, or illegal drugs
                  </strong>{" "}
                  on the ground/venue.
                </li>
                <li style={item}>
                  Vandalism or destruction of venue property.
                </li>
                <li style={item}>
                  Social media abuse or defamatory posts directed against the
                  tournament, organisers, or officials.
                </li>
                <li style={item}>
                  Display or shouting of political, religious, or caste-based
                  slogans or banners.
                </li>
              </ul>
            </li>
            <li style={item}>
              <strong>6.3 Player Responsibilities (Do&apos;s):</strong>
              <ul style={nestedListStyle}>
                <li style={item}>
                  Teams and players must report on time. Punctuality is
                  mandatory; late teams will forfeit points/matches as per the
                  Organiser&apos;s discretion.
                </li>
                <li style={item}>
                  Players must wear their allotted team jersey and compete in
                  the true spirit of the game.
                </li>
              </ul>
            </li>
            <li style={item}>
              <strong>6.4 Disciplinary Process &amp; Penalties:</strong> An
              on-field report by the Umpire and an off-field report by the
              Organiser shall be treated as final evidence. Penalties include
              Warning, Fine, Match Ban, Tournament Ban,{" "}
              <strong>Lifetime Ban</strong> from Aamdar Chashak, and
              forfeiture of fees/prize money as decided by the Disciplinary
              Committee.
            </li>
          </ul>

          <h3 style={sectionTitle}>
            SECTION 7: INJURY &amp; LIABILITY WAIVER
          </h3>
          <ul style={listStyle}>
            <li style={item}>
              <strong>7.1 Assumption of Risk:</strong> Cricket is a physical
              sport involving inherent risks. Every player participates entirely
              at their own risk.
            </li>
            <li style={item}>
              <strong>7.2 Limitation of Liability:</strong> The Organiser,
              sponsors, venue owners, and ground staff shall{" "}
              <strong>NOT</strong> be liable for any injury, illness, loss of
              life, or loss/damage of personal property during travel, practice
              sessions, or matches.
            </li>
            <li style={item}>
              <strong>7.3 Insurance &amp; First-Aid:</strong> Players are
              required to carry their own medical insurance. Basic first-aid
              will be provided on the ground on a humanitarian basis only.
            </li>
          </ul>

          <h3 style={sectionTitle}>
            SECTION 8: MEDIA, IMAGE &amp; INTELLECTUAL PROPERTY RIGHTS
          </h3>
          <ul style={listStyle}>
            <li style={item}>
              <strong>8.1 Consent for Media Use:</strong> Players and Team
              Owners grant irrevocable consent to the Organiser to capture and
              use their name, photograph, video, and match footage for
              promotion, live streaming, social media, and sponsor campaigns
              without any monetary payment or royalty.
            </li>
            <li style={item}>
              <strong>8.2 Intellectual Property:</strong> All intellectual
              property—including the title <strong>&quot;Aamdar Chashak&quot;</strong>,
              logos, graphics, photos, and match video footage—belongs solely to
              the Organiser.
            </li>
            <li style={item}>
              <strong>8.3 Data Protection:</strong> Personal data collected
              during registration will be used exclusively for tournament
              management and will not be sold to third parties.
            </li>
          </ul>

          <h3 style={sectionTitle}>
            SECTION 9: PRIZES &amp; FINANCIAL PAYMENTS
          </h3>
          <ul style={listStyle}>
            <li style={item}>
              <strong>9.1 Prize Structure:</strong> Prizes are as officially
              announced by the Organiser and are subject to revision based on
              tournament sponsorship.
            </li>
            <li style={item}>
              <strong>9.2 Disbursal Terms:</strong> Prize money will be
              transferred via bank transfer within <strong>30 days</strong>{" "}
              following the final match, subject to applicable statutory TDS
              deductions.
            </li>
            <li style={item}>
              <strong>9.3 Forfeiture:</strong> No player or Team Owner can claim
              prize money if they or their team are disqualified for misconduct
              or rule violations.
            </li>
          </ul>

          <h3 style={sectionTitle}>
            SECTION 10: CANCELLATION &amp; FORCE MAJEURE
          </h3>
          <ul style={listStyle}>
            <li style={item}>
              <strong>10.1 Event Contingencies:</strong> The Organiser reserves
              the right to reschedule, change venues, alter match formats, or
              cancel the tournament due to heavy rain, adverse weather, ground
              unavailability, law and order issues, government regulations, or
              any event beyond control.
            </li>
            <li style={item}>
              <strong>10.2 Refund Discretion:</strong> If the tournament is
              cancelled due to force majeure, the Organiser will decide on the
              issuance of refunds, if any, strictly after deducting
              administrative and operational expenses incurred. No additional
              compensation will be provided beyond the Organiser&apos;s
              discretion.
            </li>
          </ul>

          <h3 style={sectionTitle}>SECTION 11: JURISDICTION</h3>
          <ul style={listStyle}>
            <li style={item}>
              <strong>11.1 Governing Law:</strong> All disputes, claims, or
              legal matters arising out of or in connection with Aamdar Chashak
              Season 2 (2027) are subject exclusively to{" "}
              <strong>Mumbai jurisdiction</strong>. Courts in Mumbai shall have
              sole and exclusive jurisdiction.
            </li>
          </ul>

          <div style={declaration}>
            <strong>
              DECLARATION &amp; ACKNOWLEDGMENT BY PLAYER / PARTICIPANT
            </strong>
            <p style={{ margin: "10px 0 0" }}>
              &quot;I have read, understood, and agreed to abide by all the
              Consolidated Terms &amp; Conditions (Sections 1 to 11) of Aamdar
              Chashak Season 2 (2027). I confirm that I submitted my
              registration through the official online form only and paid no
              cash to any individual. I agree to play exclusively for my
              auctioned team, maintain strict discipline on and off the field,
              and accept that any applicable refund will only be remitted to my
              original payment source within 15 working days if I remain unsold
              in the auction. I accept all decisions of the Organiser as final
              and binding.&quot;
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AamdarChashakTerms;
